import { Button, notification } from "antd";
import { useParams } from "react-router-dom";

import React from "react";
import { TenantService } from "../../../../Services";
export const DeleteSection = ({ section, refetchSections }) => {
	const { tenantName } = useParams();
	return (
		<Button
			type="danger"
			onClick={async () => {
				const { data } = await TenantService.deleteTenantSection({
					tenantName,
					sectionId: section._id
				});
				if (data.status === 200) {
					notification.success({ message: "Section deleted successfully" });
					refetchSections();
					return;
				}
				notification.error({ message: "Failed to delete section" });
			}}
		>
			Delete
		</Button>
	);
};

export default DeleteSection;
